import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  public scrollToTop: EventEmitter<null> = new EventEmitter<null>();

  public isPublicNotificationVisible: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }
}
